var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9145 19H1.52475C0.684 19 0 18.3332 0 17.5138V5.31644C0 4.80047 0.209594 4.29519 0.574156 3.93003L3.92944 0.57475C4.29994 0.203656 4.79275 0 5.31644 0H13.9139C14.7541 0 15.4375 0.666187 15.4375 1.48497V4.91854L14.25 6.14661V1.48497C14.25 1.32109 14.0992 1.1875 13.9139 1.1875H5.31644C5.10981 1.1875 4.91566 1.26766 4.76959 1.41372L1.41372 4.76959C1.27003 4.91328 1.1875 5.11278 1.1875 5.31644V17.5138C1.1875 17.6783 1.33891 17.8125 1.52475 17.8125H13.9139C14.0992 17.8125 14.25 17.6789 14.25 17.515V14.7729L15.4375 13.5448V17.515C15.4375 18.3338 14.7547 19 13.9145 19ZM1.78125 5.34375C1.78125 5.6715 2.04725 5.9375 2.375 5.9375H4.45312C5.27131 5.9375 5.9375 5.27131 5.9375 4.45312V2.375C5.9375 2.04725 5.6715 1.78125 5.34375 1.78125C5.016 1.78125 4.75 2.04725 4.75 2.375V4.45312C4.75 4.617 4.617 4.75 4.45312 4.75H2.375C2.04725 4.75 1.78125 5.016 1.78125 5.34375ZM11.3321 14.7071L19.3321 6.70711L17.9179 5.29289L10.625 12.5858L8.33211 10.2929L6.91789 11.7071L9.91789 14.7071L10.625 15.4142L11.3321 14.7071Z",
    fill: "#1B8C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/approved-icon.d6b3ac11fb04f0e6fa8296498bf5d591.svg";
export { ForwardRef as ReactComponent };